import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'
import { hydrateRoot } from 'react-dom/client'
import ServicesExperience from './services/ServicesExperience'
import { servicePaths } from './services/metadata'
import './index.css'
import './theme/design-system.css'
import './theme/paper-theme.css'
import './theme/night-game.css'
import { initializeDugoutTheme } from './theme/themes'

initializeDugoutTheme()

const params = new URLSearchParams(window.location.search)
const direction = params.get('type')
if (import.meta.env.DEV && direction && ['prototype'].includes(direction)) {
  void import('./typography/preview').then(module => module.activateTypePreview(direction, params.get('typeTheme') === 'paper'))
}
const root = document.getElementById('root')!
const servicePath = window.location.pathname.replace(/\/$/, '')
if (import.meta.env.DEV && servicePath === '/typography') {
  void import('./typography/TypographyLab').then(module => ReactDOM.createRoot(root).render(<module.default />))
} else if (servicePaths.includes(servicePath)) {
  const services = <BrowserRouter><ServicesExperience /></BrowserRouter>
  if (root.dataset.servicesPrerendered === 'true') hydrateRoot(root, services)
  else ReactDOM.createRoot(root).render(services)
} else {
  ReactDOM.createRoot(root).render(<React.StrictMode><App /></React.StrictMode>)
}
